import * as ReactQuery from "@tanstack/react-query";
import { MutationOption, queryClient } from "libs/react-query";
import * as Brm from "services/brm";
import * as KeyFactory from "./installation-query-key-factory";

interface IInstallationNameProps {
  installationId: string | null;
  newName: string;
}

/**
 * Upload the given file as the image for the CD
 *
 * @param param0 upload file data
 * @returns
 */
export const setInstallationName = ({ installationId, newName }: IInstallationNameProps) => {
  return installationId === null
    ? Promise.reject(new Error("Invalid installationId id"))
    : Brm.installationApi.setInstallationName(installationId, { body: newName });
};

interface ISetNameProps {
  options?: MutationOption<typeof setInstallationName>;
}

/**
 * Upload the given formdata to to the upload service.
 *
 * @returns react-query Mutation.
 */
export const useSetInstallationName = ({ options }: ISetNameProps = {}) => {
  return ReactQuery.useMutation({
    onSettled: (data, err, variables) => {
      queryClient.invalidateQueries(KeyFactory.installationKeys.all);
      queryClient.invalidateQueries(KeyFactory.installationKeys.installation(variables.installationId));
    },
    ...options,
    mutationFn: setInstallationName,
  });
};
